// Role level helper utilities for frontend RBAC.
// Lower level = higher privilege. Matches backend `Role.level`:
//   0 Super Admin, 1 Admin, 2 Manager, 3 Viewer.
// When a user has no level info (stale session), deny by default (viewer).

export const ROLE_LEVELS = {
  SUPER_ADMIN: 0,
  ADMIN: 1,
  MANAGER: 2,
  VIEWER: 3,
};

const levelOf = (user) => {
  const level = user?.roleLevel ?? user?.role?.level;
  return typeof level === "number" ? level : ROLE_LEVELS.VIEWER;
};

export const canRead = (user) => levelOf(user) <= ROLE_LEVELS.VIEWER;
export const canCreate = (user) => levelOf(user) <= ROLE_LEVELS.MANAGER;
export const canEdit = (user) => levelOf(user) <= ROLE_LEVELS.MANAGER;
export const canDelete = (user) => levelOf(user) <= ROLE_LEVELS.ADMIN;
export const isSuperAdmin = (user) => levelOf(user) <= ROLE_LEVELS.SUPER_ADMIN;
